import React, { useEffect, useState, CSSProperties } from 'react'

type ProgressiveBackgroundProps = {
  lowRes: string
  highRes: string
  className?: string
  style?: CSSProperties
  children?: React.ReactNode
  id?: string
}

const ProgressiveBackground: React.FC<ProgressiveBackgroundProps> = ({
  lowRes,
  highRes,
  className,
  style,
  children,
  id
}) => {
  const [bgImage, setBgImage] = useState(lowRes)

  useEffect(() => {
    const img = new Image()
    img.src = highRes
    img.onload = () => {
      setBgImage(highRes)
    }
  }, [highRes])

  return (
    <div
      id={id}
      className={className}
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: 'cover',
        // backgroundPosition: 'center',
        transition: 'background-image 0.5s ease-in-out',
        ...style, // 👈 Allow additional styles to be passed
      }}
    >
      {children}
    </div>
  )
}

export default ProgressiveBackground
